import { render, staticRenderFns } from "./TreeEdit.vue?vue&type=template&id=581e63f4"
import script from "./TreeEdit.vue?vue&type=script&lang=js"
export * from "./TreeEdit.vue?vue&type=script&lang=js"
import style0 from "./TreeEdit.vue?vue&type=style&index=0&id=581e63f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports